import { render, staticRenderFns } from "./RentalRequestStatus.vue?vue&type=template&id=231de778&scoped=true"
import script from "./RentalRequestStatus.vue?vue&type=script&lang=js"
export * from "./RentalRequestStatus.vue?vue&type=script&lang=js"
import style0 from "./RentalRequestStatus.vue?vue&type=style&index=0&id=231de778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231de778",
  null
  
)

export default component.exports